import { OccupierTplTypeEnum } from '@/bundles/Occupier/types';

export const occupiersChartMetricLabels = {
  record_count: 'Record Count',
  property_size: 'Space Size',
  land_size: 'Land Size',
}

export const occupierTplTypeLabels = {
  [OccupierTplTypeEnum.occupant]: '3PL Occupant',
  [OccupierTplTypeEnum.operator]: '3PL Operator',
  [OccupierTplTypeEnum.tenant]: '3PL Tenant',
};
